import React, { Fragment } from 'react';
import Helmet from 'react-helmet';

import WebGalleryHeaderContainer from '../containers/WebGalleryHeaderContainer';
import WebGalleryAlbumFolder from '../components/WebGalleryAlbumFolder';

const WebGalleriesFolderView = () => {
  return (
    <Fragment>
      <Helmet>
        <title>Web Gallery &ndash; Waldo</title>
      </Helmet>

      <WebGalleryHeaderContainer />
      <WebGalleryAlbumFolder />
    </Fragment>
  );
};

export default WebGalleriesFolderView;
